import { useState, useEffect } from "react";

// Handles auto-dismissal of notifications.
function useAutoDismissing(notifications, {
	isEnabled,
	timeout,
}) {
	// Set notifications to auto-dismiss after some timeout.
	const [notificationsToAutoDismiss, setNotificationsToAutoDismiss] = useState([]);
	useEffect(() => {
		// Only proceed if we're auto-dismissing.
		if (!isEnabled) {
			return;
		}

		notifications
			.filter((notification) => {
				// Ignore things we're already set to auto-dismiss.
				return !notificationsToAutoDismiss
					.find(({ notificationId }) => notificationId === notification.id);
			})
			.forEach((notification) => {
				// Set this notification to auto-dismiss & record it.
				setNotificationsToAutoDismiss((willAutoDismissSoFar) => [
					...willAutoDismissSoFar, {
						notificationId: notification.id,
						timeout: setTimeout(
							notification.hide,
							timeout,
						),
					},
				]);
			});
	}, [
		notifications,
		notificationsToAutoDismiss,
		isEnabled,
		timeout,
	]);

	// Clear auto-dismiss timeouts when appropriate.
	useEffect(() => {
		if (isEnabled || notificationsToAutoDismiss.length === 0) {
			return;
		}

		// Clear the dismissing timeouts.
		notificationsToAutoDismiss
			.forEach((notification) => clearTimeout(notification.timeout));

		// Reset the things we'll auto-dismiss.
		setNotificationsToAutoDismiss([]);
	}, [
		isEnabled,
		notificationsToAutoDismiss,
	]);
}

export default useAutoDismissing;



// WEBPACK FOOTER //
// ./src/apps/notifications_footer/util/useAutoDismissing.js